// extracted by mini-css-extract-plugin
module.exports = {"information":"_93444fe79c--information--bjSVI","infoRow":"_93444fe79c--infoRow--fRwEb"};